module.exports = "<span class=\"help-icon fa fa-question-circle-o\" *ngIf=\"showComponent()\"></span>\r\n"